var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2550 5104 c-222 -48 -408 -237 -456 -464 -39 -183 17 -382 147 -524 66 -73 145 -124 249 -160 74 -26 99 -30 190 -30 88 0 118 5 185 28 239 82 393 281 411 530 21 288 -186 561 -471 621 -86 18 -169 18 -255 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 4436 c-200 -51 -365 -224 -404 -424 -63 -326 193 -635 526 -636 161 0 297 60 405 182 187 209 180 527 -17 726 -63 64 -134 110 -208 136 -76 27 -229 35 -302 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4074 4072 c-98 -46 -131 -165 -71 -258 32 -50 114 -89 170 -80 88 14 157 93 157 180 0 49 -32 109 -76 142 -47 36 -122 43 -180 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 2913 c-212 -33 -372 -191 -406 -401 -37 -228 108 -461 329 -528 81 -25 220 -22 294 4 198 71 321 245 321 452 0 254 -188 456 -440 473 -38 3 -81 3 -98 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4700 2671 c-110 -34 -175 -119 -174 -231 1 -139 97 -234 234 -234 204 0 313 231 181 385 -60 71 -161 104 -241 80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131 1379 c-74 -14 -164 -63 -217 -116 -163 -167 -163 -423 0 -586 63 -64 109 -90 193 -112 236 -62 474 97 514 344 35 218 -124 435 -346 471 -68 11 -83 11 -144 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4087 1260 c-159 -40 -259 -192 -227 -347 49 -235 332 -322 500 -153 115 114 118 298 7 413 -74 75 -186 110 -280 87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 709 c-225 -46 -349 -287 -255 -496 34 -75 103 -145 178 -179 53 -24 75 -28 147 -28 108 0 187 32 256 106 207 222 76 572 -226 601 -30 3 -75 2 -100 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading (2).4c9bd64d66d3df9ca935d6961fac2ad8.svg";
export { ForwardRef as ReactComponent };